/* Couch Guys PSL — theme script. No dependencies. */
(function () {
  'use strict';

  var T = window.theme || { routes: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: T.currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Header offset for mobile menu ---------- */
  function setHeaderBottom() {
    var h = $('[data-header]');
    if (h) document.documentElement.style.setProperty('--header-bottom', h.getBoundingClientRect().bottom + 'px');
  }
  setHeaderBottom();
  window.addEventListener('resize', setHeaderBottom);
  $$('.mobile-menu').forEach(function (d) {
    d.addEventListener('toggle', function () {
      setHeaderBottom();
      document.body.style.overflow = d.open ? 'hidden' : '';
    });
  });

  /* ---------- Reveal on scroll ---------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#CartDrawer');
  var overlay = $('[data-cart-overlay]');
  var lastFocus = null;

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { drawer.focus(); }, 50);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    var items = $('[data-cart-items]');
    var foot = $('[data-cart-foot]');
    if (!items) return;
    if (!cart.item_count) {
      items.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><a class="btn btn--primary btn--sm" href="' + esc(T.routes.all || '/collections/all') + '">Shop couches</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    items.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200&height=200&crop=center' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="muted" style="font-size:13.5px;">' + esc(item.variant_title) + '</p>' : '';
      return '<div class="cart-line">' +
        '<a class="cart-line__img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><h3 style="font-size:16px;"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h3>' + variant +
        '<div class="qty">' +
          '<button type="button" data-qty="' + esc(item.key) + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty="' + esc(item.key) + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div>' +
        '<div style="margin-top:6px;"><button type="button" class="remove-link" data-qty="' + esc(item.key) + '" data-to="0">Remove</button></div></div>' +
        '<div class="price__now" style="font-size:15.5px;">' + money(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');
    var sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    if (foot) foot.hidden = false;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, qty) {
    return fetch((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawer) {
    $$('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(openCart, openCart);
      });
    });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
    overlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart(); });
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      b.disabled = true;
      changeLine(b.getAttribute('data-qty'), parseInt(b.getAttribute('data-to'), 10));
    });
  }

  /* ---------- Product form: buy now vs add to cart ---------- */
  var form = $('[data-product-form]');
  if (form) {
    var idInput = $('[data-variant-id]', form);
    var select = $('[data-variant-select]', form);

    if (select) {
      select.addEventListener('change', function () {
        idInput.value = select.value;
        var opt = select.options[select.selectedIndex];
        var priceEl = $('[data-price] .price__now');
        if (priceEl && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url.toString());
      });
    }

    function goCheckout() {
      var rt = form.querySelector('input[name="return_to"]');
      if (!rt) {
        rt = document.createElement('input');
        rt.type = 'hidden';
        rt.name = 'return_to';
        form.appendChild(rt);
      }
      rt.value = '/checkout';
      form.submit();
    }

    form.addEventListener('submit', function (e) {
      var submitter = e.submitter || document.activeElement;
      if (submitter && submitter.hasAttribute('data-buy-now')) {
        e.preventDefault();
        submitter.disabled = true;
        submitter.textContent = 'Heading to checkout...';
        goCheckout();
        return;
      }
      if (!drawer) return; // fall back to normal form post
      e.preventDefault();
      var btn = $('[data-add-to-cart]', form);
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      fetch((T.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
            return data;
          });
        })
        .then(fetchCart)
        .then(openCart)
        .catch(function (err) { alert(err.message); })
        .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
    });

    var sticky = $('[data-sticky-buy]');
    var stickyBtn = $('[data-sticky-buy-now]');
    if (stickyBtn) stickyBtn.addEventListener('click', goCheckout);
    if (sticky && 'IntersectionObserver' in window) {
      var buyRow = $('.buy', form.parentNode) || form;
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-shown', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('a, button', sticky).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      }).observe(buyRow);
    }
  }

  /* ---------- Gallery thumbnails ---------- */
  var mainImg = $('[data-gallery-main] img');
  $$('[data-gallery-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = t.getAttribute('data-src');
      mainImg.setAttribute('srcset', t.getAttribute('data-srcset'));
      mainImg.alt = t.getAttribute('data-alt') || '';
      $$('[data-gallery-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
    });
  });

  /* ---------- Collection sort ---------- */
  var sort = $('[data-sort-select]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Viewing page: pre-fill item + Calendly ---------- */
  var viewing = $('[data-viewing]');
  if (viewing) {
    var params = new URLSearchParams(window.location.search);
    var item = (params.get('item') || '').slice(0, 200);
    var field = $('[data-items-field]', viewing);
    if (item) {
      if (field && !field.value) field.value = item;
      var pill = $('[data-item-pill]', viewing);
      var name = $('[data-item-name]', viewing);
      if (pill && name) { name.textContent = item; pill.hidden = false; }
    }
    var frame = $('[data-calendly-frame]', viewing);
    if (frame) {
      try {
        var cal = new URL(frame.getAttribute('data-calendly-url'));
        if (/(^|\.)calendly\.com$/.test(cal.hostname)) {
          cal.searchParams.set('embed_domain', window.location.hostname);
          cal.searchParams.set('embed_type', 'Inline');
          cal.searchParams.set('hide_gdpr_banner', '1');
          cal.searchParams.set('primary_color', 'ba5b3f');
          if (item) cal.searchParams.set('a1', item);
          frame.src = cal.toString();
          // Calendly reports its content height on every step. Size the frame to fit so the
          // Schedule button is never hidden inside it (CSS min-height stays as the floor).
          window.addEventListener('message', function (ev) {
            if (ev.source !== frame.contentWindow || !ev.data || typeof ev.data.event !== 'string') return;
            if (ev.data.event === 'calendly.page_height') {
              var h = parseInt(ev.data.payload && ev.data.payload.height, 10);
              if (h > 0) frame.style.height = h + 'px';
            } else if (ev.data.event === 'calendly.date_and_time_selected' || ev.data.event === 'calendly.event_scheduled') {
              // New step (details form or confirmation): bring the top of the frame back into view.
              var hdr = $('[data-header]');
              var off = (hdr ? hdr.offsetHeight : 0) + 16;
              var top = frame.getBoundingClientRect().top;
              if (top < off) window.scrollTo({ top: window.pageYOffset + top - off, behavior: 'smooth' });
            }
          });
        } else {
          frame.remove();
        }
      } catch (e) { frame.remove(); }
    }
  }
})();
